import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17.67 17.667a12 12 0 0 1 -5.67 3.333a12 12 0 0 1 -8.5 -15c.794 .036 1.583 -.006 2.357 -.124m3.128 -.926a11.997 11.997 0 0 0 3.015 -1.95a12 12 0 0 0 8.5 3a12 12 0 0 1 -1.116 9.376","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

const IconShieldOff = createReactComponent('outline', 'shield-off', 'ShieldOff', __iconNode);

export default IconShieldOff;